Vue.component('ack-distributor-dashboard', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-distributor-dashboard',
  mixins: [languageMixins],
  created() {

  },
  mounted() {
    appLog.log('ack-distributor-dashboard mounted')
    this.setPageIsLoading(false)
    if (window.hbspt) {
      this.createForm()
      this.setPageIsLoading(false)
    } else {
      this.loadScript().then(()=>{
        this.createForm()
        this.setPageIsLoading(false)
      })
    }
  },
  props:{

  },
  computed: {
    //...Vuex.mapGetters('sliders', ['slidersLists']),
    //...Vuex.mapGetters('articles', ['articlesArray']),
    isMobile(){
      return this.$parent.isMobile
    },
  },
  data() {
    return {
      pageId: 'distributor-dashboard-page',
      currentTab: 'home',
    }
  },
  methods: {
    setTab(tab){
      this.currentTab = tab
    },



    loadScript() {
      return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = '//js.hsforms.net/forms/v2.js'
        script.onload = resolve
        document.body.appendChild(script)
      })
    },

    createForm() {
      if (window.hbspt) {
        window.hbspt.forms.create({
          target: '#hs-form',
          region: 'na1',
          portalId: '2471334',
          formId: '927353b8-eaee-4ec5-84c9-0f5ee65c9420',
          
        })
      }
    },

    scrollToTop() {
      window.scrollTo({top: 300, left: 100, behavior: 'smooth'})
    },
  },
  beforeDestroy() {

  },
  watch: {
    currentTab: {
      handler() {
          if(this.currentTab == 'support-ticket'){
              this.createForm()
          }
          //this.scrollToTop()
      },
      deep: false
    }
  }
})